import React from 'react';
import { Menu as PloneMenu, MenuItem, Popover } from '@plone/components';
import { clsx } from 'clsx';
import './Menu.scss';

export interface ESSMenuProps {
  variant?: 'default' | 'compact';
  className?: string;
  [key: string]: any; // Allow any props from @plone/components Menu
}

/**
 * ESS Menu Component
 *
 * A dropdown menu component for navigation and actions.
 * Wraps @plone/components Menu with ESS design system styling.
 *
 * Note: This component wraps @plone/components Menu in a styled div.
 * Menu is typically used with MenuItem components for menu items.
 *
 * @example
 * ```tsx
 * import { ESSMenu, MenuItem } from './components/Molecules/Menu';
 * import { Button } from './components/Atoms/Button';
 *
 * <ESSMenu variant="default">
 *   <MenuItem>Option 1</MenuItem>
 *   <MenuItem>Option 2</MenuItem>
 *   <MenuItem>Option 3</MenuItem>
 * </ESSMenu>
 * ```
 */
export const ESSMenu: React.FC<ESSMenuProps> = ({
  variant = 'default',
  className,
  ...props
}) => {
  return (
    <div className={clsx('ess-menu', `ess-menu--${variant}`, className)}>
      <PloneMenu {...props} />
    </div>
  );
};

// Re-export MenuItem and Popover for convenience
export { MenuItem, Popover };

export default ESSMenu;
